import * as React from 'react';

import { notification } from './../../utils/notification';

interface IProps {
    children?: React.ReactNode;
    type?: 'success' | 'warning';
}

export default class Message extends React.Component<IProps, any> {
    public componentDidMount() {
        this.trigger();
    }

    public componentDidUpdate(prevProps: IProps) {
        if (this.props.children !== prevProps.children || this.props.type !== prevProps.type) {
            this.trigger();
        }
    }

    private trigger = () => {
        const msg = (this.props.children ? this.props.children : '') as string;

        switch (this.props.type) {
            case 'success':
                notification.success(msg);
                break;
            case 'warning':
                notification.warn(msg);
                break;

            default:
                notification.info(msg);
        }
    };

    public render() {
        return null;
    }
}
